import {FC} from 'react';
import {useField} from 'formik';
import {useTranslation} from 'react-i18next';
import {TShow} from '../../../../../hooks/useShow';
import {useTimetableDays} from '../../../hooks/useTimetableDays';
import DisabledInput from '../../../../../component/input/disabledInput/DisabledInput';
import {tsToDate, tsGetDateAndMonth} from '../../../../../library/dates';

interface DayDateFieldProps {
    show: TShow;
}

const DayDateField: FC<DayDateFieldProps> = ({show}) => {
    const {t} = useTranslation('timetable');
    const {conferenceDays} = useTimetableDays();
    const [field, meta] = useField<number>('dayIndex');
    const day = conferenceDays[field.value];

    const value = field.value === -1
        ? t('noDateLectures')
        : day
            ? `${tsToDate(day.timestamp, 'he', null, 'dddd')} (${tsGetDateAndMonth(day.timestamp)})`
            : '';

    const toggle = () => { if(show.isOpen) show.close(); else show.open(); };

    return (
        <DisabledInput
            text={t('dayAndDate')}
            icon="calendarOutline"
            value={value}
            events={{onClick: toggle}}
            className=""
            dataCyName=""
            hasArrow
            invalid={!!(meta.touched && meta.error)}
        />

    );
};

export default DayDateField;
